/* AITO — gallery zoom.
   A native <dialog> on paper, opened by a click on the photograph itself.
   Loaded only by blocks/_product-gallery.liquid when zoom is on, so the
   shared bundle stays free of it (page-specific behaviour does not go into
   aito.js). The browser owns focus, Escape and the top layer; this script
   swaps the image, keeps the counter and the thumbnail rail in step, preloads
   the neighbours, and locks the page scroll while the dialog is open. */
(function () {
  "use strict";

  function initZoom(scope) {
    (scope || document).querySelectorAll(".product-media[data-zoom]").forEach(function (root) {
      if (root.getAttribute("data-zoom-ready")) return;
      var dialog = root.querySelector("dialog[data-zoom-dialog]");
      var img = dialog && dialog.querySelector("[data-zoom-img]");
      var current = dialog && dialog.querySelector("[data-zoom-current]");
      var stage = dialog && dialog.querySelector("[data-zoom-stage]");
      var thumbs = dialog ? Array.prototype.slice.call(dialog.querySelectorAll("[data-zoom-go]")) : [];
      /* no native dialog, no zoom: the photograph stays a photograph */
      if (!dialog || !img || !thumbs.length || typeof dialog.showModal !== "function") return;
      root.setAttribute("data-zoom-ready", "1");

      var at = 0;

      function thumbFor(i) {
        return thumbs.filter(function (b) { return +b.getAttribute("data-zoom-go") === i; })[0];
      }
      function preload(i) {
        var b = thumbFor(i);
        if (b) { var p = new Image(); p.src = b.getAttribute("data-zoom-src"); }
      }
      function show(i) {
        var b = thumbFor(i);
        if (!b) return;
        at = i;
        /* the gallery's copy is already on screen, so it shows at once; the
           full-size file replaces it the moment it has loaded */
        var small = root.querySelector('[data-zoom-open="' + i + '"] img');
        var big = b.getAttribute("data-zoom-src");
        img.src = (small && (small.currentSrc || small.src)) || big;
        img.alt = b.getAttribute("data-zoom-alt") || "";
        var loader = new Image();
        loader.onload = function () { if (at === i) img.src = big; };
        loader.src = big;
        thumbs.forEach(function (t) {
          var on = t === b;
          t.classList.toggle("is-current", on);
          if (on) t.setAttribute("aria-current", "true");
          else t.removeAttribute("aria-current");
        });
        if (current) current.textContent = thumbs.indexOf(b) + 1;
        if (b.scrollIntoView) b.scrollIntoView({ block: "nearest", inline: "center", behavior: "smooth" });
        var pos = thumbs.indexOf(b);
        if (thumbs[pos + 1]) preload(+thumbs[pos + 1].getAttribute("data-zoom-go"));
        if (thumbs[pos - 1]) preload(+thumbs[pos - 1].getAttribute("data-zoom-go"));
      }
      function step(delta) {
        var pos = thumbs.indexOf(thumbFor(at));
        var next = thumbs[pos + delta];
        if (next) show(+next.getAttribute("data-zoom-go"));
      }
      var railLoaded = false;
      function open(i) {
        /* the rail is lazy while the dialog is hidden; the first open wants it whole */
        if (!railLoaded) {
          railLoaded = true;
          thumbs.forEach(function (t) { var im = t.querySelector("img"); if (im) im.loading = "eager"; });
        }
        show(i);
        document.documentElement.classList.add("zoom-open");
        dialog.showModal();
      }
      function close() {
        if (dialog.open) dialog.close();
      }
      function unlock() {
        document.documentElement.classList.remove("zoom-open");
      }

      /* the photographs in the gallery */
      root.addEventListener("click", function (e) {
        var b = e.target.closest ? e.target.closest("[data-zoom-open]") : null;
        if (!b || dialog.contains(b)) return;
        e.preventDefault();
        open(+b.getAttribute("data-zoom-open"));
      });

      /* inside the dialog: a thumbnail goes to its image, the image goes to the
         next one, the paper around the image closes, and so does the button */
      dialog.addEventListener("click", function (e) {
        var go = e.target.closest("[data-zoom-go]");
        if (go) { show(+go.getAttribute("data-zoom-go")); return; }
        if (e.target.closest("[data-zoom-close]")) { close(); return; }
        if (e.target === img) { step(1); return; }
        if (e.target === dialog || e.target === stage) close();
      });

      dialog.addEventListener("keydown", function (e) {
        var rtl = document.documentElement.getAttribute("dir") === "rtl";
        if (e.key === "ArrowRight") { step(rtl ? -1 : 1); e.preventDefault(); }
        else if (e.key === "ArrowLeft") { step(rtl ? 1 : -1); e.preventDefault(); }
      });

      /* Escape (cancel) and dialog.close() both end here; the stylesheet's
         html:has(dialog.pz[open]) rule locks the scroll on its own, this class is
         the fallback for browsers without :has() */
      dialog.addEventListener("cancel", unlock);
      dialog.addEventListener("close", unlock);
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { initZoom(); });
  else initZoom();

  /* the editor re-renders the section on every setting change */
  document.addEventListener("shopify:section:load", function (e) {
    initZoom(e.target && e.target.querySelector ? e.target : document);
  });
})();
